import { withInstall } from '@vuemap/vue-amap-util'
import Canvas from './Canvas.vue'

export const ElAmapLayerCanvas = withInstall(Canvas)
export default ElAmapLayerCanvas
